import paymentMethodMapping from "@/api/accounting/payment-method-mapping";

import { baseState, baseMutations } from "@/store/mixins";
import { split } from "lodash";

export const state = {
    ...baseState,
    formViewDatas: []
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_VIEW_MODELS(state, { data, index }) {
        if (!index) {
            state.formViewDatas = data;
        } else {
            split(index, ",").forEach(el => {
                state.formViewDatas[el] = data[el];
            });
        }
    },
    CLEAR_STATE(state) {
        state.formViewDatas = [];
    }
};

export const actions = {
    fetch(context, attributes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return paymentMethodMapping.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },
    store(context, data) {
        return paymentMethodMapping.store(data);
    },
    update(context, { id, data }) {
        return paymentMethodMapping.update(id, data);
    },
    destroy(context, { id, data }) {
        return paymentMethodMapping.destroy(id, data);
    },
    async getFormViewModel(context, { params, index }) {
        let response = await paymentMethodMapping.formViewModel({ params: params });
        context.commit("SET_VIEW_MODELS", {
            data: response.data,
            index: index
        });
        return Promise.resolve(response);
    }
};
